export enum ClosetStateEnum {
  NOT_LOADING = 'NOT_LOADING',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  LOAD_FAILED = 'LOAD_FAILED',
  DO_NOT_SUPPORT = 'DO_NOT_SUPPORT',
}
